<script>
  export let tabs
  export let value

  tabs = Object.values(tabs).filter((t) => !t.hidden)

  value = tabs[0].value

  function selectTab (tab) {
    value = tab
  }
</script>

<div class="tabs">
  {#each tabs as tab}
    <button
      class="tab"
      on:click={() => selectTab(tab.value)}
      class:active={value === tab.value}
    >
      {tab.name}
    </button>
  {/each}
</div>

<style>
  .tabs {
    display: flex;
    align-items: center;
    border-bottom: 3px solid #e3e3e3;
    width: 100%;
  }

  .tab {
    padding: 0.5rem 1.5rem;
    background: white;
    cursor: pointer;
    border: none;
    border-bottom: 3px solid #e3e3e3;
    position: relative;
    bottom: -3px;
  }

  .tab.active {
    border-bottom: 3px solid #3b82f6;
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>